<template>
  <modal-structure
    btn-cancel-text="Cancel"
    btn-ok-text="OK"
    :has-close-button="true"
  >
    <template v-slot:header />
    <template v-slot:content>
      <div>
        <ul :style="{display:'flex'}">
          <li
            v-for="(file, index) in listOfFiles.slice(-10)"
            :key="file && file.key"
          >
            <button @click="handleSelection(file.key)">
              File {{ index }}
            </button>
          </li>
        </ul>
        <br>
        <img
          :src="url"
          alt="picture"
        >
      </div>
    </template>
    <template v-slot:footer>
      <!-- <button>button</button> -->
    </template>
  </modal-structure>
</template>

<script>
import ModalStructure from './ModalStructure'
export default {

  name: 'TestModal2',
  components: {
    ModalStructure
  },
  data () {
    return {
      url: 'http://placehold.it/300x200',
      listOfFiles: []
    }
  },

  async created () {
    this.listOfFiles = await this.$s3.list('66ceed8129e141e0b7bc7d08c9163bb1')
  },

  methods: {
    async handleSelection (key) {
      this.url = await this.$s3.get(key)
    }
  }
}
</script>

<style lang="css" scoped>
img {
  margin: 0 auto;
  text-align: center;
}
</style>
